import React from 'react'
import Grid from '../layout/grid'

function renderRows(lista){
    return lista.map(item => (
        <option value={item.chave} >{item.valor}</option>
      ))
}

export default props => (
    <Grid cols={props.cols}>
      <div class="form-group">
      <label htmlFor={props.name}>{props.label}</label>
        <select {...props.input} class="form-control" name={props.name} 
         placeholder={props.placeholder}
         readOnly={props.readOnly} 
         disabled={props.disabled}>
          {renderRows(props.lista||[])}
        </select>
      </div>
    </Grid>
)


// WEBPACK FOOTER //
// ./src/common/form/select.jsx